var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#2A2A2A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard Config",
    filter: "url(#filter0_d_216_2425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Billing Main"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_2425)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -960,
    y: -310,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "#EAEDFC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 14"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_216_2425)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -812,
    y: -171,
    width: 1330,
    height: 790,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 16",
    clipPath: "url(#clip2_216_2425)",
    filter: "url(#filter1_d_216_2425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 5",
    filter: "url(#filter2_d_216_2425)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -69,
    y: -65,
    width: 302,
    height: 168,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Value: 70",
    d: "M-39.6751 22L-45.6811 5.61H-43.8551L-38.5751 20.438H-38.9271L-33.6691 5.61H-31.8211L-37.8271 22H-39.6751ZM-26.9084 22.264C-27.6564 22.264 -28.3237 22.1247 -28.9104 21.846C-29.497 21.5527 -29.959 21.1567 -30.2964 20.658C-30.6337 20.1593 -30.8024 19.5873 -30.8024 18.942C-30.8024 18.326 -30.6704 17.7687 -30.4064 17.27C-30.1424 16.7567 -29.7317 16.324 -29.1744 15.972C-28.617 15.62 -27.9057 15.3707 -27.0404 15.224L-22.4204 14.454V15.95L-26.6444 16.654C-27.495 16.8007 -28.111 17.072 -28.4924 17.468C-28.859 17.864 -29.0424 18.3333 -29.0424 18.876C-29.0424 19.404 -28.837 19.8513 -28.4264 20.218C-28.001 20.5847 -27.4584 20.768 -26.7984 20.768C-25.9917 20.768 -25.2877 20.5993 -24.6864 20.262C-24.085 19.91 -23.6157 19.4407 -23.2784 18.854C-22.941 18.2673 -22.7724 17.6147 -22.7724 16.896V13.904C-22.7724 13.2 -23.029 12.628 -23.5424 12.188C-24.0557 11.748 -24.723 11.528 -25.5444 11.528C-26.263 11.528 -26.8937 11.7113 -27.4364 12.078C-27.979 12.43 -28.3824 12.892 -28.6464 13.464L-30.1424 12.65C-29.9224 12.1513 -29.5777 11.6967 -29.1084 11.286C-28.6244 10.8753 -28.0744 10.5527 -27.4584 10.318C-26.8424 10.0687 -26.2044 9.944 -25.5444 9.944C-24.679 9.944 -23.9164 10.1127 -23.2564 10.45C-22.5817 10.7873 -22.061 11.2567 -21.6944 11.858C-21.313 12.4447 -21.1224 13.1267 -21.1224 13.904V22H-22.7724V19.646L-22.5304 19.888C-22.7357 20.328 -23.0584 20.7313 -23.4984 21.098C-23.9237 21.45 -24.4297 21.736 -25.0164 21.956C-25.5884 22.1613 -26.219 22.264 -26.9084 22.264ZM-17.2885 22V5.346H-15.6385V22H-17.2885ZM-7.64119 22.264C-8.46253 22.264 -9.21053 22.0733 -9.88519 21.692C-10.5599 21.296 -11.0952 20.7533 -11.4912 20.064C-11.8725 19.36 -12.0632 18.5533 -12.0632 17.644V10.208H-10.4132V17.446C-10.4132 18.0767 -10.2885 18.634 -10.0392 19.118C-9.77519 19.5873 -9.41586 19.954 -8.96119 20.218C-8.49186 20.482 -7.95653 20.614 -7.35519 20.614C-6.75386 20.614 -6.21853 20.482 -5.74919 20.218C-5.27986 19.9393 -4.91319 19.5507 -4.64919 19.052C-4.38519 18.5387 -4.25319 17.93 -4.25319 17.226V10.208H-2.60319V22H-4.25319V19.712L-3.87919 19.8C-4.15786 20.5627 -4.63453 21.164 -5.30919 21.604C-5.98386 22.044 -6.76119 22.264 -7.64119 22.264ZM6.59813 22.264C5.49813 22.264 4.5008 22 3.60613 21.472C2.72613 20.9293 2.02947 20.1887 1.51613 19.25C1.0028 18.3113 0.746133 17.248 0.746133 16.06C0.746133 14.872 0.995466 13.8233 1.49413 12.914C1.9928 11.99 2.66747 11.264 3.51813 10.736C4.38347 10.208 5.35147 9.944 6.42213 9.944C7.2728 9.944 8.02813 10.1053 8.68813 10.428C9.3628 10.736 9.9348 11.1613 10.4041 11.704C10.8735 12.232 11.2328 12.8333 11.4821 13.508C11.7315 14.168 11.8561 14.85 11.8561 15.554C11.8561 15.7007 11.8488 15.8693 11.8341 16.06C11.8195 16.236 11.7975 16.4193 11.7681 16.61H1.80213V15.07H10.8221L10.0301 15.73C10.1621 14.9233 10.0668 14.2047 9.74413 13.574C9.43613 12.9287 8.9888 12.4227 8.40213 12.056C7.81547 11.6747 7.15547 11.484 6.42213 11.484C5.6888 11.484 5.0068 11.6747 4.37613 12.056C3.76013 12.4373 3.27613 12.9727 2.92413 13.662C2.57213 14.3367 2.4328 15.1433 2.50613 16.082C2.4328 17.0207 2.57947 17.842 2.94613 18.546C3.32747 19.2353 3.8408 19.7707 4.48613 20.152C5.14613 20.5333 5.85013 20.724 6.59813 20.724C7.46347 20.724 8.18947 20.5187 8.77613 20.108C9.3628 19.6973 9.83947 19.184 10.2061 18.568L11.6141 19.316C11.3795 19.844 11.0201 20.3353 10.5361 20.79C10.0521 21.23 9.4728 21.5893 8.79813 21.868C8.13813 22.132 7.4048 22.264 6.59813 22.264ZM15.7773 22V19.58H17.5373V22H15.7773ZM15.7773 12.628V10.208H17.5373V12.628H15.7773ZM26.1625 22L33.5545 7.15H25.3705V5.61H35.3805V7.15L28.0105 22H26.1625ZM44.8838 22.264C43.5931 22.264 42.4565 21.912 41.4738 21.208C40.5058 20.4893 39.7505 19.4993 39.2078 18.238C38.6651 16.962 38.3938 15.4807 38.3938 13.794C38.3938 12.1073 38.6651 10.6333 39.2078 9.372C39.7505 8.096 40.5058 7.106 41.4738 6.402C42.4418 5.698 43.5711 5.346 44.8618 5.346C46.1525 5.346 47.2818 5.698 48.2498 6.402C49.2178 7.106 49.9731 8.096 50.5158 9.372C51.0585 10.6333 51.3298 12.1073 51.3298 13.794C51.3298 15.4807 51.0585 16.962 50.5158 18.238C49.9878 19.514 49.2398 20.504 48.2718 21.208C47.3038 21.912 46.1745 22.264 44.8838 22.264ZM44.8838 20.614C45.8225 20.614 46.6438 20.328 47.3478 19.756C48.0518 19.184 48.6018 18.392 48.9978 17.38C49.3938 16.3533 49.5918 15.158 49.5918 13.794C49.5918 12.43 49.3938 11.242 48.9978 10.23C48.6018 9.20333 48.0518 8.41133 47.3478 7.854C46.6438 7.282 45.8151 6.996 44.8618 6.996C43.9231 6.996 43.1018 7.282 42.3978 7.854C41.6938 8.41133 41.1438 9.20333 40.7478 10.23C40.3518 11.242 40.1538 12.43 40.1538 13.794C40.1538 15.1433 40.3518 16.3313 40.7478 17.358C41.1438 18.3847 41.6938 19.184 42.3978 19.756C43.1165 20.328 43.9451 20.614 44.8838 20.614Z",
    fill: "black"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 10",
    filter: "url(#filter3_b_216_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-955 -310H559V672H-955V-310Z",
    fill: "#D9D9D9",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 2",
    filter: "url(#filter4_d_216_2425)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -401,
    y: -24,
    width: 454,
    height: 410,
    rx: 7,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 3",
    cx: 13,
    cy: 12.5573,
    rx: 13,
    ry: 12.5573,
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 2",
    y1: -0.5,
    x2: 25.2846,
    y2: -0.5,
    transform: "matrix(0.73167 0.681659 -0.692706 0.72122 3.5 4.43198)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 3",
    y1: -0.5,
    x2: 24.5624,
    y2: -0.5,
    transform: "matrix(-0.712471 0.701701 -0.712471 -0.701701 21.5 3.93954)",
    stroke: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_216_2425",
    x: -968,
    y: -311,
    width: 1535,
    height: 998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.0235294 0 0 0 0 0.137255 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_216_2425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_216_2425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_216_2425",
    x: -831,
    y: -122,
    width: 1338,
    height: 711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_216_2425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_216_2425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_216_2425",
    x: -85,
    y: -79,
    width: 334,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0392157 0 0 0 0 0.172549 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_216_2425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_216_2425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_216_2425",
    x: -975,
    y: -330,
    width: 1554,
    height: 1022,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_216_2425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_216_2425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_216_2425",
    x: -417,
    y: -38,
    width: 486,
    height: 442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0392157 0 0 0 0 0.172549 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_216_2425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_216_2425",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -960,
    y: -310,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_216_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -812,
    y: -171,
    width: 1330,
    height: 790,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_216_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1330,
    height: 703,
    fill: "white",
    transform: "translate(-827 -122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.63e4941917b6a0eaa83fe65487d18754.svg";
export { ForwardRef as ReactComponent };